import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';

export type IconItem = {
  className?: string;
  color?: 'pink' | 'blue' | 'dark' | 'white' | 'orange' | 'gray';
  faIconDefinition?: IconDefinition;
  svg?: ReactElement;
  size?:
    | '2xs'
    | 'xs'
    | 'sm'
    | 'lg'
    | 'xl'
    | '2xl'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x';
};

type IconProps = {
  icon: IconItem;
  className?: string;
};

export function Icon({ icon, className }: IconProps): ReactElement {
  const iconSize = icon?.size || 'lg';

  const color = () => {
    switch (icon.color) {
      case 'pink':
        return 'var(--pink)';
      case 'blue':
        return 'var(--blue)';
      case 'dark':
        return 'var(--dark)';
      case 'white':
        return 'var(--white)';
      case 'orange':
        return 'rgb(246, 147, 88)';
      case 'gray':
        return 'rgba(221, 206, 219, 0.8)';
      default:
        return 'var(--dark)';
    }
  };

  const iconClassName = `${icon?.className} ${className}`;

  if (icon?.faIconDefinition) {
    return (
      <FontAwesomeIcon
        color={color()}
        icon={icon.faIconDefinition}
        size={iconSize}
        className={iconClassName}
      />
    );
  }

  return icon?.svg || null;
}
